<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HuZr1B/images/9780446561082.jpg?1730238036800" alt="This image is the cover for the book Saving Room for Dessert"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saving Room for Dessert
      </h1>
      <p class="bookDescription body article font2">
        <p>For former Air Force veteran and ex-mall security guard William Rayford, making the cut as Rocksburg's first African American cop fulfilled one of his life's ambitions, even though it sometimes still gives him a case of the Steel City Blues. Rayford well-knows this town's dark history of prejudice, but dealing with it is something else. Now, with his fellow officers, Rayford is ready for whatever Rocksburg throws his way, even if it means patrolling the river flats, where things can get deadly pretty quickly.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K. C. Constantine
      </h2>
      
      <p class="authorDescription body article">K. C. Constantine is an American mystery author. Little is known about Kosak, as he prefers anonymity and has given only a few interviews. He was born in 1934 and served in the Marines in the early 1950s. He lives in Greensburg, Pennsylvania with wife Linda.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grand Central Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9de87326